import Lookup from '@/components/UI/Lookup';
import Http from '@/support/http';
import { api as apiRoute } from '@/support/route';
import { useState } from 'react';
//@ts-expect-error - old hook form - replace with `react-hook-form@latest`
import { Controller, useFormContext } from 'react-hook-form';
import { defaultValue, handleChange, renderLabel } from './Select';
import type { MetadataFieldWithValue } from '@/model/Metadata.model';
import { FC } from 'react';
import { _isEmpty } from '@/littledash';
import '@/components/UI/FormFields/LookupOptions.scss';
import './MetadataFields.scss';

interface SelectLookupProps {
  field: MetadataFieldWithValue;
  isMulti?: boolean;
  testId?: string;
  name: string;
}

export const SelectLookup: FC<SelectLookupProps> = ({ field, isMulti = false, testId = 'select-lookup', name }) => {
  const [apiError, setApiError] = useState<Error | boolean>(false);
  const { control } = useFormContext();

  const loadOptions = async ({ inputValue, page }: { inputValue: string; page: string | number }) => {
    let url = apiRoute('metadata.options.show', { id: field.id });
    url = `${url}?page=${page}`;
    if (inputValue) {
      url = `${url}&query=${encodeURIComponent(inputValue)}`;
    }

    try {
      const {
        data: { data, links },
      } = await Http.get(url);
      const { next } = links;
      const options = data.map(({ value }: { value: string }) => ({
        label: renderLabel(value),
        value,
      }));

      return { options, hasMore: !!next };
    } catch (error) {
      setApiError(error as Error);
    }
  };

  const customGetOptionLabel = ({ label }: { label: string }) => {
    return (
      <div className="flex items-center">
        <span className="ml1 w-100 lookup-option-label">{label}</span>
      </div>
    );
  };

  return (
    <Controller
      control={control}
      defaultValue={field.value}
      name={name}
      rules={{
        validate: {
          required: (value: any) => {
            if (field.required && _isEmpty(value)) {
              return 'This field is required';
            }
          },
        },
      }}
      render={({ name, onChange }: { name: string; onChange: (data: string | Array<string>) => void }) => (
        <div className="lookup-select-container" data-testid={testId}>
          <Lookup
            name={name}
            isMulti={isMulti}
            defaultValue={defaultValue(field, isMulti)}
            loadOptions={loadOptions}
            handleSelect={(data: string | Array<string>) => handleChange(onChange, data, isMulti)}
            cacheOptions={false}
            getOptionLabel={customGetOptionLabel}
          />
          {apiError && <p className="f7 red">There was a problem fetching metadata</p>}
        </div>
      )}
    />
  );
};
